import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { MainService } from 'src/app/services/main.service'

import { FundLiterature } from './fund-literature.model'

const profileIndex = 0

@Injectable({
  providedIn: 'root',
})
export class FundLiteratureService {
  fundLiteratureModel = {} as FundLiterature
  fundLiteratureModel$: Observable<FundLiterature>

  constructor(
    private readonly mainService: MainService,
    private readonly http: HttpClient,
  ) {}

  /*eslint complexity: [2, 10] */
  getModelData(): Observable<FundLiterature> {
    return new Observable((subscriber) => {
      this.mainService
        .getFundLiteratureObservable()
        .pipe(take(1))
        .subscribe((ovObs) => {
          if (
            Object.keys(ovObs).length !== 0 &&
            ovObs[0]?.name !== 'HTTPError'
          ) {
            const profilePos = ovObs[profileIndex]?.fundProfile

            this.fundLiteratureModel = {
              is529: profilePos?.is529,
              fundId: profilePos?.fundId,
              isETF: profilePos?.isETF,
              isMutualFund: profilePos?.isMutualFund,
              propectus: profilePos?.isETF ? 'ETPR' : 'MFPR',
              report: profilePos?.isMutualFund ? 'MFRP' : 'ETRP',
            }
          }
          subscriber.next(this.fundLiteratureModel)
          subscriber.complete()
        })
    })
  }

  public downloadPdf(url: string, fundId: string) {
    return this.http.get(`vmf/api/${fundId}`.concat('/pdf-downloader'), {
      params: { url: encodeURI(url) },
      responseType: 'text',
    })
  }
}
